export default "__VITE_ASSET___sE8NBcn__"